import React from 'react';
import { CurlySeduccion } from './pages/CurlySeduccion';
type AppProps = {
  showTestimonials?: boolean;
  showStickyCta?: boolean;
  debugPixel?: boolean;
};
export function App({
  showTestimonials = true,
  showStickyCta = true,
  debugPixel = false
}: AppProps) {
  return <CurlySeduccion showTestimonials={showTestimonials} showStickyCta={showStickyCta} debugPixel={debugPixel} data-id="element-0" data-mp="3fahxqsfjmvaj" />;
}